import { jsx as _jsx } from "react/jsx-runtime";
import createSvgIcon from "./utils/createSvgIcon";
export default createSvgIcon(/*#__PURE__*/ _jsx("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3 4.5003C3 3.6731 3.673 3 4.5003 3h14.9994C20.3269 3 21 3.673 21 4.5003v14.9994C21 20.3269 20.3269 21 19.4997 21H4.5003C3.6731 21 3 20.3269 3 19.4997zM12 7.5a.75.75 0 0 1 .75.75v3h3a.75.75 0 0 1 0 1.5h-3v3a.75.75 0 0 1-1.5 0v-3h-3a.75.75 0 0 1 0-1.5h3v-3A.75.75 0 0 1 12 7.5",
    clipRule: "evenodd"
}), "StatusInvited", {
    "style": {
        "fill": "none"
    },
    "viewBox": "0 0 24 24"
});
